import { Injectable } from '@angular/core';
import { HttpClient,HttpResponse } from '@angular/common/http';

import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { InterviewItem } from './interview';
import { Entrevistas, Entrevista, ImageDedalo, Informant, Audiovisual} from './entrevista'

@Injectable()
export class DedaloService {

  apiUrl : string = "https://api.industriapaisaia.eus/interviews"
  entrevistas : Entrevista[]

  constructor(
    private http: HttpClient,
  ) {}

  getInterviews() : Observable<Entrevistas> {
    return this.http.get<Entrevistas>(this.apiUrl);
  }

}
